import { isDeletable } from '../../utils/statuses';
import { useContext } from 'react';
import { APIContext } from '@monash/portal-frontend-common';
import BaseBulkDeleteModalContents from '../base-bulk-delete-modal-contents/BaseBulkDeleteModalContents';

const BulkDeleteModalContents = ({
  links,
  onClose,
  deleteLink: deleteLinkInParent,
  updateChecked,
  ...modalSectionProps
}) => {
  const { deleteLink } = useContext(APIContext);

  return (
    <BaseBulkDeleteModalContents
      relevantLinks={links.filter(isDeletable)}
      onClose={onClose}
      deleteRequestFn={deleteLink}
      deleteLinkInParent={deleteLinkInParent}
      updateChecked={updateChecked}
      {...modalSectionProps}
    />
  );
};

export default BulkDeleteModalContents;
